const selectInitialState = {
  dashboard: null,
  isUpdating: false,
};

const selected = (state = selectInitialState, action) => {
  switch (action.type) {
    case 'SELECT_DASHBOARD':
      return {
        ...state,
        dashboard: action.dashboard,
      };

    case 'SAVE_DASHBOARD_SUCCESS':
      return {
        ...state,
        dashboard: action.dashboard.id,
        isUpdating: false,
      };

    case 'UPDATE_DASHBOARD_SUCCESS':
      return {
        ...state,
        dashboard: action.dashboard.id,
        isUpdating: false,
      };

    case 'DELETE_DASHBOARD_SUCCESS':
      return {
        ...state,
        dashboard: null,
        isUpdating: false,
      };

    case 'SAVE_DASHBOARD':
    case 'UPDATE_DASHBOARD':
    case 'DELETE_DASHBOARD':
      return {
        ...state,
        isUpdating: true,
      };

    case 'SAVE_DASHBOARD_FAILURE':
    case 'UPDATE_DASHBOARD_FAILURE':
    case 'DELETE_DASHBOARD_FAILURE':
      return {
        ...state,
        isUpdating: false,
      };

    default:
      return state;
  }
};

export default selected;

export const getSelected = (state) => state.dashboard;
export const getIsUpdating = (state) => state.isUpdating;
